import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../+store/app.states';
import { Observable, of } from 'rxjs';
import { catchError, tap, first, map, filter } from 'rxjs/operators';
import { getIsAuth } from '../+store/auth.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private store: Store<AppState>, public router: Router) {}

  canActivate(): Observable<any> {
    return this.store.pipe(
      select(getIsAuth),
      filter(isAuth => isAuth !== null),
      first(),
      map(isAuth => {
        if (isAuth) {
          return true;
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          const start = urlParams.get('start');
          const currentUrl = window.location.pathname + window.location.search;
          const encodedUrl = encodeURIComponent(currentUrl);
          if (start === 'signup') {
            this.router.navigate(['auth/signup'], {
              queryParams: { redirect: encodedUrl }
            });
          } else {
            this.router.navigate(['auth/login'], {
              queryParams: { redirect: encodedUrl }
            });
          }
          return false;
        }
      }),
      catchError(error => {
        return of(false);
      })
    );
  }
}
